import { render, staticRenderFns } from "./insuranceTable.vue?vue&type=template&id=75f2d36c&scoped=true&"
import script from "./insuranceTable.vue?vue&type=script&lang=js&"
export * from "./insuranceTable.vue?vue&type=script&lang=js&"
import style0 from "./insuranceTable.vue?vue&type=style&index=0&id=75f2d36c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f2d36c",
  null
  
)

export default component.exports